import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';

type ContentExitContextValue = {
  hasQueue: boolean;
  setHasQueue: (value: boolean) => void;
};

const ContentExitContext = createContext<ContentExitContextValue | null>(null);

export const ContentExitProvider = ({ children }: { children: ReactNode }) => {
  const [hasQueue, setHasQueue] = useState(false);
  const value = useMemo(() => ({ hasQueue, setHasQueue }), [hasQueue]);

  return <ContentExitContext.Provider value={value}>{children}</ContentExitContext.Provider>;
};

export const useContentExitQueue = (hasItems: boolean) => {
  const context = useContext(ContentExitContext);
  const setHasQueue = context?.setHasQueue;

  useEffect(() => {
    if (!setHasQueue) return;
    setHasQueue(hasItems);
    return () => setHasQueue(false);
  }, [hasItems, setHasQueue]);
};

export const useContentExitState = () => {
  const context = useContext(ContentExitContext);
  if (!context) {
    throw new Error('useContentExitState must be used within ContentExitProvider');
  }
  return context;
};
